import { useState, useEffect } from 'react';
import companyService from '../services/companyService';

interface FeatureFlags {
  aiHarold: boolean;
  masterControlMapping: boolean;
}

export const useFeatureFlags = () => {
  const [features, setFeatures] = useState<FeatureFlags>({
    aiHarold: false,
    masterControlMapping: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const settings = await companyService.getCompanySettings(undefined, "features");
        setFeatures({
          aiHarold: settings?.experimentalFeatures?.aiHarold ?? false,
          masterControlMapping: settings?.advancedFeatures?.masterControlMapping ?? false,
        });
      } catch (error) {
        console.error("Failed to fetch feature flags:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeatures();
  }, []);

  return { features, loading };
};
